exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.inspectr-footer {\n    padding-top: 30px;\n    padding-bottom:15px;\n    font-family: 'IBMPlexSans-Light', sans-serif;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    background-color: #424747;\n    color: white;\n    text-align: left;\n    justify-content: space-between;\n }\n\n .footer-text{\n    line-height: 30px;\n    text-align: left;\n    padding-bottom: 20px;\n    font-family: 'IBMPlexSans-Light', sans-serif; \n    display: flex;\n    text-align: center;\n    margin-left: 20px;\n}\n\n.footer-item {\n    margin-left: 5px;\n    margin-right: 5px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/footer/Footer.css
// module id = Ikhv
// module chunks = 0